import { watchFields } from "./clarity_fields"

const TAG_SRC = "https://www.clarity.ms/tag/"

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] }

declare global {
  interface Window {
    clarity?: ClarityFn
  }
}

type Identity = { id?: string; hint?: string; tags?: Record<string, string> }

function projectId(): string | null {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="clarity-project-id"]')
  return meta?.content?.trim() || null
}

function identity(): Identity | null {
  const raw = document.querySelector<HTMLMetaElement>('meta[name="clarity-identity"]')?.content
  if (!raw) return null

  try {
    return JSON.parse(raw) as Identity
  } catch {
    return null
  }
}

function sendIdentity(): void {
  const who = identity()
  if (!who?.id) return

  window.clarity?.("identify", who.id, undefined, undefined, who.hint)
  for (const [ key, value ] of Object.entries(who.tags ?? {})) {
    window.clarity?.("set", key, String(value))
  }
}

let watchingVisits = false

function watchTurboVisits(): void {
  if (watchingVisits) return

  watchingVisits = true
  document.addEventListener("turbo:load", sendIdentity)
}

function queueStub(): ClarityFn {
  if (window.clarity) return window.clarity

  const clarity: ClarityFn = (...args: unknown[]) => {
    ;(clarity.q = clarity.q || []).push(args)
  }
  window.clarity = clarity
  return clarity
}

function injectTag(id: string): void {
  if (document.querySelector(`script[src^="${TAG_SRC}"]`)) return

  const tag = document.createElement("script")
  tag.async = true
  tag.src = TAG_SRC + encodeURIComponent(id)
  document.head.appendChild(tag)
}

export function startClarity(): void {
  const id = projectId()
  if (!id) return

  queueStub()
  window.clarity?.("consentv2", { ad_Storage: "granted", analytics_Storage: "granted" })
  sendIdentity()
  watchTurboVisits()
  watchFields()
  injectTag(id)
}
